import { AlertCircle, CheckCircle2, Info } from 'lucide-react'
import { useEffect, useState } from 'react'

import type { ToastPayload } from '@/lib/toast'
import { subscribeToast } from '@/lib/toast'

const TOAST_DURATION = 3600
const TOAST_EXIT_DURATION = 220

type ToastViewItem = ToastPayload & {
  isLeaving: boolean
  isVisible: boolean
}

function getToastIcon(variant: ToastPayload['variant']) {
  if (variant === 'success') {
    return <CheckCircle2 size={18} />
  }

  if (variant === 'info') {
    return <Info size={18} />
  }

  return <AlertCircle size={18} />
}

export function ToastViewport() {
  const [items, setItems] = useState<ToastViewItem[]>([])

  useEffect(() => {
    function dismissToast(id: string) {
      setItems(current =>
        current.map(item => (item.id === id ? { ...item, isLeaving: true, isVisible: false } : item))
      )

      window.setTimeout(() => {
        setItems(current => current.filter(item => item.id !== id))
      }, TOAST_EXIT_DURATION)
    }

    return subscribeToast(payload => {
      const nextItem: ToastViewItem = {
        ...payload,
        isLeaving: false,
        isVisible: false,
      }

      setItems(current => {
        const deduped = current.filter(item => item.message !== payload.message)
        return [...deduped, nextItem].slice(-4)
      })

      window.requestAnimationFrame(() => {
        setItems(current =>
          current.map(item => (item.id === payload.id ? { ...item, isVisible: true } : item))
        )
      })

      window.setTimeout(() => {
        dismissToast(payload.id)
      }, TOAST_DURATION)
    })
  }, [])

  return (
    <div className="toast-viewport" aria-live="polite" aria-relevant="additions text">
      {items.map(item => (
        <div
          key={item.id}
          className={`toast toast--${item.variant} ${item.isVisible ? 'is-visible' : ''} ${item.isLeaving ? 'is-leaving' : ''}`}
        >
          <div className="toast__icon">{getToastIcon(item.variant)}</div>
          <div className="toast__body">
            <strong>{item.title ?? '提示'}</strong>
            <p>{item.message}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
